import * as React from "react";
import { Path, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MTIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MT" {...props}>
    <Rect width={16} height={12} fill="#fff" rx={1} />
    <Mask id="a" fill="#fff">
      <Path d="M5 4.531a.5.5 0 0 1 .416.491l-.002.018H7v2H5.364A.497.497 0 0 1 5 7.313V9.04H3V7.308a.498.498 0 0 1-.333-.268H1v-2h1.618l-.002-.018A.5.5 0 0 1 3 4.537V3.04h2v1.491Z" />
    </Mask>
    <Path
      fill="#A0A0A0"
      d="M5 4.531a.5.5 0 0 1 .416.491l-.002.018H7v2H5.364A.497.497 0 0 1 5 7.313V9.04H3V7.308a.498.498 0 0 1-.333-.268H1v-2h1.618l-.002-.018A.5.5 0 0 1 3 4.537V3.04h2v1.491Z"
    />
    <Path
      fill="#FECA00"
      d="M5 4.531h-.5v.422l.416.071L5 4.531Zm.416.491h.5-.5Zm-.002.018-.5-.017-.017.517h.517v-.5ZM7 5.04h.5v-.5H7v.5Zm0 2v.5h.5v-.5H7Zm-1.636 0v-.5h-.313l-.137.282.45.218ZM5 7.313l-.084-.492-.416.07v.422H5ZM5 9.04v.5h.5v-.5H5Zm-2 0h-.5v.5H3v-.5Zm0-1.732h.5v-.395l-.384-.092L3 7.308Zm-.333-.268.45-.218-.137-.282h-.313v.5ZM1 7.04H.5v.5H1v-.5Zm0-2v-.5H.5v.5H1Zm1.618 0v.5h.517l-.017-.517-.5.017Zm-.002-.018h-.5.5ZM3 4.537l.116.487.384-.092v-.395H3ZM3 3.04v-.5h-.5v.5H3Zm2 0h.5v-.5H5v.5Zm0 1.491-.084.493v-.001h1a1 1 0 0 0-.832-.985L5 4.531Zm.416.491h-.5a.464.464 0 0 1 .005-.064v-.004.004a.56.56 0 0 0-.007.065l.5.017.5.017a.456.456 0 0 1-.005.052s0 .002 0 0l.004-.025a.536.536 0 0 0 .003-.062h-.5Zm-.002.018v.5H7v-1H5.414v.5ZM7 5.04h-.5v2h1v-2H7Zm0 2v-.5H5.364v1H7v-.5Zm-1.636 0-.45-.218h.001l.001-.001.084.492.084.493a.997.997 0 0 0 .73-.548l-.45-.218ZM5 7.313h-.5V9.04h1V7.313H5ZM5 9.04v-.5H3v1h2v-.5Zm-2 0h.5V7.308h-1V9.04H3Zm0-1.732.116-.487s0 .001 0 0l-.449.219-.45.218c.13.266.372.466.667.536L3 7.308Zm-.333-.268v-.5H1v1h1.667v-.5ZM1 7.04h.5v-2h-1v2H1Zm0-2v.5h1.618v-1H1v.5Zm1.618 0 .5-.017a.544.544 0 0 0-.006-.065v-.004.004a.428.428 0 0 1 .004.064h-1a.54.54 0 0 0 .004.062l.003.025c0 .002 0 0 0 0a.397.397 0 0 1-.005-.052l.5-.017Zm-.002-.018h.5v.002L3 4.537l-.116-.486a1 1 0 0 0-.768.971h.5ZM3 4.537h.5V3.04h-1v1.497H3ZM3 3.04v.5h2v-1H3v.5Zm2 0h-.5v1.491h1V3.04H5Z"
      mask="url(#a)"
    />
    <Path
      fill="#E31D1C"
      fillRule="evenodd"
      d="M8 0h8v12H8V0Z"
      clipRule="evenodd"
    />
    <Mask
      id="b"
      width={8}
      height={12}
      x={8}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <Path
        fill="#fff"
        fillRule="evenodd"
        d="M8 0h8v12H8V0Z"
        clipRule="evenodd"
      />
    </Mask>
  </Icon>
);
